import CommonService from '@/services/CommonService';
import {
  SET_DRAWER,
  RESET_ALL_TOGGLE,
  SET_MESSAGE_MODAL,
  TOGGLE_BILL_MODAL_VISIBLE,
  TOGGLE_PAGE_IS_LOADING,
  SET_ACTIVE_ELEMENT,
  START_LOADING,
  END_LOADING,
  SET_TABLE_DIALOG,
} from '../mutation-types';

// state
const localState = {
  drawer: true,
  messageModal: '',
  activeElement: null,
  isLoading: false,
  pageIsLoading: false,
  tableDialog: false,
  isBillModalVisible: false,
  staffSubLocations: []
};

// mutations
const mutations = {
  [RESET_ALL_TOGGLE](state) {
    Object.assign(state, localState());
  },

  [SET_DRAWER](state, drawer = null) {
    state.drawer = drawer == null ? !state.drawer : drawer;
  },

  [SET_MESSAGE_MODAL](state, message = '') {
    state.messageModal = message;
  },

  [SET_TABLE_DIALOG](state, status) {
    state.tableDialog = status;
  },

  [TOGGLE_BILL_MODAL_VISIBLE](state, status = null) {
    state.isBillModalVisible = (status !== null) ? status : !state.isBillModalVisible;
  },

  [TOGGLE_PAGE_IS_LOADING](state, status = null) {
    state.pageIsLoading = (status !== null) ? status : !state.pageIsLoading;
  },

  [SET_ACTIVE_ELEMENT](state, element) {
    if (state.isLoading || !element || element.tagName.toLowerCase() === 'input') return;
    if (element.tagName.toLowerCase() === 'button') {
      state.activeElement = element;
      return;
    }
    state.activeElement = CommonService.getButtonNodeParent(element);
  },

  [START_LOADING](state) {
    setTimeout(() => {
      state.isLoading = true;
      if (!state.activeElement) return;
      CommonService.addLoading(state.activeElement);
    }, 100);
  },

  [END_LOADING](state) {
    state.isLoading = false;
    if (!state.activeElement) return;
    CommonService.removeLoading(state.activeElement);
    state.activeElement = null;
  },
};

export default {
  state: localState,
  mutations,
};
